<template>
    <div>
    <div v-show="load" class="wrap_loader">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
    <div v-html="content">
    </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import Preloader from '../sig-preloader';
import axios from 'axios';
export default {
    data() {
        return {
            content:null,
            load:true,
        }
    },
    components: {
        'loader':Preloader
    },
    props: {
        postId:{default:null}
    },
    computed : {
        ...mapGetters({
            getApiUri:'api/getBlogApi'
        })
    },
    mounted() {
        axios.get(this.getApiUri + '/' + this.postId, { headers: {
                'Content-type': 'application/json'
              }}).then(response => (this.content = response.data))
              .finally(() => (this.load = false));;
    }
}
</script>
<style lang="less" scoped>
p {
    margin-bottom: 8px;
}
.wrap_loader {
    width: 100%;
    display: block;
}
.lds-ring {
    display: block;
    margin: 0 auto;
    position: relative;
    width: 64px;
    height: 64px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
        transform: rotate(0deg);
  }
  100% {
        transform: rotate(360deg);
  }
}
</style>
